import React from 'react';
import {ReactComponent as MenuItemDarkIco} from "../../../../../images/icons/menus/menu-item-dark.svg";
import {ReactComponent as MenuItemIco} from "../../../../../images/icons/menus/menu-item.svg";
import {useTranslation} from "react-i18next";
import AppConfig from "../../../../services/AppConfig";
import CartItemItems from "../CartItems/CartItemItems";
import Money from "../../../Common/Money";

interface Props {
    item: Record<string, any>;
    cartItem: Record<string, any>;
    promotion?: Record<string, any>;
}

const DisabledCartItem = ({item, cartItem, promotion}: Props) => {
    const {t} = useTranslation();
    const name = item ? item.translation.name : cartItem.name;

    const renderItemPrice = () => {
        const totalMoney = cartItem.total_money.amount;

        if (cartItem.discount_money && cartItem.discount_money.amount !== 0) {
            const subTotalPrice = cartItem.total_money.amount + cartItem.discount_money.amount;

            return (
                <>
                    <span className="text-muted me-2">
                        <del>
                        <Money
                            value={subTotalPrice}
                            currency='PLN'/>
                        </del>
                    </span>
                    <span className="text-danger">
                    <Money
                        value={totalMoney}
                        currency='PLN'/>
                    </span>
                </>
            )
        }

        return (
            <Money
                value={totalMoney}
                currency='PLN'/>
        )
    }

    const renderName = () => {
        let result = name;

        if (cartItem.quantity > 1) {
            result += ` (x${cartItem.quantity})`;
        }

        return result;
    }

    return (
        <div className={"cart-item"}>
            <div className={"cart-item-img"}>
                {
                    item.image_link?.small ? (
                        <img src={item.image_link.small} alt={t("common.word.product_image")}/>
                    ) : (
                        AppConfig.isDarkMode() ?
                            <MenuItemDarkIco className="img"/> : <MenuItemIco className="img"/>
                    )
                }
            </div>
            <div className={"cart-item-body"}>
                <h3>{renderName()}</h3>
                <div className={"cart-item-items"}>
                    <CartItemItems orderItem={cartItem}/>
                </div>
                {promotion && (
                    <div className={"cart-item-promotion text-success"}>
                        {promotion.name}
                    </div>
                )}
                <div className={"cart-item-prices"}>
                    {renderItemPrice()}
                </div>
                {item.comment && (
                    <div className="order-comment mt-2 rounded-2">
                        <p className="mb-0">{item.comment}</p>
                    </div>
                )}
            </div>
        </div>
    )
}

export default DisabledCartItem;